(function() {
  'use strict';

  var WISHLIST_STORAGE_KEY = 'shopify_wishlist';
  var ADDED_FAVORITE_CLASS = 'added-to-favorites';
  var FAVORITE_BUTTON_SELECTOR = 'a.add-to-favorites, a.move-to-favorites';

  function getWishlist() {
    var stored;
    try {
      stored = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY));
    } catch (error) {
      stored = [];
    }

    if (!Array.isArray(stored)) {
      return [];
    }

    var entries = [];
    var seen = {};

    for (var i = 0; i < stored.length; i++) {
      var entry = normalizeEntry(stored[i]);
      if (!entry) {
        continue;
      }

      seen[entry.variantId] = mergeEntries(seen[entry.variantId], entry);
    }

    for (var key in seen) {
      if (Object.prototype.hasOwnProperty.call(seen, key)) {
        entries.push(seen[key]);
      }
    }

    if (entries.length !== stored.length) {
      setWishlist(entries);
    }

    return entries;
  }

  function setWishlist(entries) {
    var normalized = [];
    var seen = {};

    for (var i = 0; i < entries.length; i++) {
      var entry = normalizeEntry(entries[i]);
      if (!entry) {
        continue;
      }

      seen[entry.variantId] = mergeEntries(seen[entry.variantId], entry);
    }

    for (var key in seen) {
      if (Object.prototype.hasOwnProperty.call(seen, key)) {
        normalized.push(seen[key]);
      }
    }

    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(normalized));
    } catch (error) {
      console.error('Error saving wishlist:', error);
    }

    window.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          wishlist: normalized
        }
      })
    );
  }

  function normalizeEntry(rawEntry) {
    if (!rawEntry) {
      return null;
    }

    if (typeof rawEntry === 'string' || typeof rawEntry === 'number') {
      return {
        variantId: String(rawEntry)
      };
    }

    if (typeof rawEntry === 'object' && rawEntry.variantId) {
      var entry = {
        variantId: String(rawEntry.variantId)
      };

      if (rawEntry.productUrl) {
        entry.productUrl = String(rawEntry.productUrl);
      }
      if (rawEntry.productHandle) {
        entry.productHandle = String(rawEntry.productHandle);
      }
      if (rawEntry.productBrand) {
        var brand = String(rawEntry.productBrand).trim();
        if (brand) {
          entry.productBrand = brand;
        }
      }
      if (rawEntry.productTitle) {
        entry.productTitle = String(rawEntry.productTitle);
      }
      if (rawEntry.productImage) {
        entry.productImage = String(rawEntry.productImage);
      }
      if (rawEntry.productImageAlt) {
        entry.productImageAlt = String(rawEntry.productImageAlt);
      }
      if (
        rawEntry.productPrice !== undefined &&
        rawEntry.productPrice !== null &&
        String(rawEntry.productPrice).trim() !== '' &&
        !isNaN(rawEntry.productPrice)
      ) {
        entry.productPrice = parseInt(rawEntry.productPrice, 10);
      }
      if (
        rawEntry.productComparePrice !== undefined &&
        rawEntry.productComparePrice !== null &&
        String(rawEntry.productComparePrice).trim() !== '' &&
        !isNaN(rawEntry.productComparePrice)
      ) {
        entry.productComparePrice = parseInt(rawEntry.productComparePrice, 10);
      }

      return entry;
    }

    return null;
  }

  function mergeEntries(existing, incoming) {
    if (!existing) {
      return incoming;
    }
    if (!incoming) {
      return existing;
    }

    var merged = {
      variantId: incoming.variantId || existing.variantId
    };

    merged.productUrl = incoming.productUrl || existing.productUrl || '';
    merged.productHandle = incoming.productHandle || existing.productHandle || '';
    var incomingBrand = typeof incoming.productBrand === 'string' ? incoming.productBrand.trim() : incoming.productBrand;
    var existingBrand = typeof existing.productBrand === 'string' ? existing.productBrand.trim() : existing.productBrand;
    merged.productBrand = incomingBrand || existingBrand || '';
    merged.productTitle = incoming.productTitle || existing.productTitle || '';
    merged.productImage = incoming.productImage || existing.productImage || '';
    merged.productImageAlt = incoming.productImageAlt || existing.productImageAlt || '';

    if (incoming.productPrice !== undefined && !isNaN(incoming.productPrice)) {
      merged.productPrice = incoming.productPrice;
    } else if (existing.productPrice !== undefined) {
      merged.productPrice = existing.productPrice;
    }

    if (incoming.productComparePrice !== undefined && !isNaN(incoming.productComparePrice)) {
      merged.productComparePrice = incoming.productComparePrice;
    } else if (existing.productComparePrice !== undefined) {
      merged.productComparePrice = existing.productComparePrice;
    }

    return merged;
  }

  function initializeFavoriteButtons() {
    var wishlist = getWishlist();
    var variantMap = {};

    for (var i = 0; i < wishlist.length; i++) {
      variantMap[wishlist[i].variantId] = true;
    }

    var favoriteButtons = document.querySelectorAll(FAVORITE_BUTTON_SELECTOR);

    for (var j = 0; j < favoriteButtons.length; j++) {
      var button = favoriteButtons[j];
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        continue;
      }

      if (variantMap[String(variantId)]) {
        button.classList.add(ADDED_FAVORITE_CLASS);
      } else {
        button.classList.remove(ADDED_FAVORITE_CLASS);
      }
    }
  }

  function handleButtonClick(event) {
    var button = event.currentTarget || event.target;

    if (button.classList.contains(ADDED_FAVORITE_CLASS)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }

    var wishlist = getWishlist();
    var variantIdStr = String(variantId);
    var entryFromButton = createEntryFromButton(button, variantIdStr);
    var index = findEntryIndex(wishlist, variantIdStr);

    if (index === -1) {
      wishlist.push(entryFromButton);
    } else {
      wishlist[index] = mergeEntries(wishlist[index], entryFromButton);
    }

    setWishlist(wishlist);

    button.classList.add(ADDED_FAVORITE_CLASS);

    if (button.classList.contains('move-to-favorites')) {
      removeCartItem(button, event);
    }
  }

  function createEntryFromButton(button, variantId) {
    var entry = {
      variantId: variantId
    };

    if (button.dataset) {
      if (button.dataset.productUrl) {
        entry.productUrl = button.dataset.productUrl;
      }
      if (button.dataset.productHandle) {
        entry.productHandle = button.dataset.productHandle;
      }
      if (button.dataset.productTitle) {
        entry.productTitle = button.dataset.productTitle;
      }
      if (button.dataset.productBrand && button.dataset.productBrand.trim() !== '') {
        entry.productBrand = button.dataset.productBrand.trim();
      }
      if (button.dataset.productImage) {
        entry.productImage = button.dataset.productImage;
      }
      if (button.dataset.productImageAlt) {
        entry.productImageAlt = button.dataset.productImageAlt;
      }
      if (button.dataset.productPrice && button.dataset.productPrice.trim() !== '') {
        var price = parseInt(button.dataset.productPrice, 10);
        if (!isNaN(price)) {
          entry.productPrice = price;
        }
      }
      if (button.dataset.productComparePrice && button.dataset.productComparePrice.trim() !== '') {
        var comparePrice = parseInt(button.dataset.productComparePrice, 10);
        if (!isNaN(comparePrice)) {
          entry.productComparePrice = comparePrice;
        }
      }
    }

    return entry;
  }

  function findEntryIndex(wishlist, variantId) {
    for (var i = 0; i < wishlist.length; i++) {
      if (wishlist[i].variantId === variantId) {
        return i;
      }
    }
    return -1;
  }

  function attachClickHandlers() {
    var favoriteButtons = document.querySelectorAll(FAVORITE_BUTTON_SELECTOR);
    for (var i = 0; i < favoriteButtons.length; i++) {
      var button = favoriteButtons[i];
      button.removeEventListener('click', handleButtonClick);
      button.addEventListener('click', handleButtonClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeFavoriteButtons();
      attachClickHandlers();
    });
  } else {
    initializeFavoriteButtons();
    attachClickHandlers();
  }

  var observer = new MutationObserver(function() {
    initializeFavoriteButtons();
    attachClickHandlers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('wishlist:updated', function() {
    initializeFavoriteButtons();
    attachClickHandlers();
  });

  function removeCartItem(button, event) {
    var line = button.getAttribute('data-line');
    if (!line) {
      return;
    }

    var cartItems = findParent(button, 'cart-items, cart-drawer-items');
    if (!cartItems) {
      cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    }

    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(line, 0, event);
      return;
    }

    var url = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
    var body = JSON.stringify({ line: parseInt(line, 10), quantity: 0 });

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: body
    })
      .then(function() {
        if (typeof window.location.reload === 'function') {
          window.location.reload();
        }
      })
      .catch(function(error) {
        console.error('Error removing cart item:', error);
      });
  }

  function findParent(element, selector) {
    var current = element;
    while (current) {
      if (current.matches && current.matches(selector)) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }
})();
